<div class="container">
	<div class="row">
		<div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
			@if (errormessage) {
			<div class="message-bad">{{errormessage}}</div>
			}
			@if (mfaInfo) {
			<div class="panel">
				<div class="heading">Set up authenticator app</div>
				<div class="content">
					<p>To enable Multi-Factor Authentication (MFA), you need to install an authenticator app on your mobile device.</p>
					<p>Some popular options include Google Authenticator, Authy, and Microsoft Authenticator.</p>
					<p>Once installed, use the app to scan the QR code below:</p>
					<div class="text-center">
						<img [src]="mfaInfo.qr_code" alt="QR Code">
					</div>
					<p class="mt-3">Or manually enter the key: <strong>{{ mfaInfo.secret }}</strong></p>
					<p class="mt-5">Then, use the authenticator app to generate a numeric code, and enter it here:</p>
					<form>
						<div class="mb-3">
							<label for="mfa_code">MFA Code</label>
							<input [(ngModel)]="mfa_code" name="mfa_code" type="text" class="form-control">
						</div>
						<div class="mb-3">
							<app-action-button submit [action]="EnableMFA" [context]="this" [disabled]="!mfa_code" processing="Enabling..." complete="MFA Enabled">Enable MFA</app-action-button>
						</div>
					</form>
				</div>
			</div>
			}
		</div>
	</div>
</div>